// extracted by mini-css-extract-plugin
export var desktop = "LogoMarquee-module--desktop--4Xpc8";
export var fadeIn = "LogoMarquee-module--fadeIn--SXtc8";
export var mobile = "LogoMarquee-module--mobile--9rnO9";
export var wrapper = "LogoMarquee-module--wrapper--os+w1";